<div class="car-detail-card my-3 d-flex flex-wrap flex-lg-nowrap align-items-stretch">
  <!-- LEFT SECTION -->
  <div class="col-12 col-lg-6 left-panel p-4">
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <div class="car-header mb-4">
          <h2 class="car-name ff-poppins-semibold m-0">
            {{ car.name || 'BMW car – White' }}
          </h2>
          <div class="car-sub">
            <!-- <span class="price ff-poppins-semibold">QAR {{ car.daily_rate }}</span>
              <span class="unit ff-poppins">/day</span> -->
            <span class="amount ff-poppins-semibold">
              {{ getDiscountedPrice(+selectedPriceLeft!) | currency: 'QAR ' : 'symbol' : '1.0-0' }}
            </span>
            <span class="per">
              <ng-container [ngSwitch]="selectedSubscriptionLeft">
                <span *ngSwitchCase="'per_minute'">Per Minute</span>
                <span *ngSwitchCase="'hourly'">Per Hour</span>
                <span *ngSwitchCase="'daily'">Per Day</span>
                <span *ngSwitchCase="'per_week'">Per Week</span>
                <span *ngSwitchCase="'per_month'">Per Month</span>
                <span *ngSwitchDefault>Per Day</span>
              </ng-container>
            </span>
          </div>
        </div>
        <div class="car-icons mb-4 d-flex flex-wrap gap-2">
          <span class="chip has-label">
            <img src="/icons/ic_car_calander.svg" alt="icon calander" />
            <span class="label">{{ car.model }}</span>
          </span>
          <span class="chip" title="Doors">
            <img src="/icons/ic_car_doors.svg" alt="icon doors" />
            <span class="label">{{ car.doors }}</span></span
          >
          <span class="chip" title="Fuel">
            <img src="/icons/ic_car_fuel.svg" alt="icon fuel" />
            <span class="label">{{ car.fuelType }}</span></span
          >
          <span class="chip" title="Engine">
            <img src="/icons/ic_car_engine.svg" alt="icon engine" />
            <span class="label">{{ car.engine }}</span></span
          >
          <span class="chip" title="Seats">
            <img src="/icons/ic_car_seats.svg" alt="icon seats" />
            <span class="label">{{ car.seats }}</span></span
          >
          <span class="chip" title="Settings">
            <img src="/icons/ic_car_trim.svg" alt="icon gear" />
            <span class="label">{{ car.transmission || '' | titleCaseKey }}</span></span
          >
        </div>
      </div>
      <div class="status-badge">
        <div class="status-box">
          <div class="km-line">
            <span class="num ff-poppins-semibold">{{ car.mileage ? car.mileage : 0 }}</span
            ><span class="unit ff-poppins">KM</span>
          </div>
          <div class="state ff-poppins-medium" *ngIf="!car.mileage">New</div>
        </div>
      </div>
    </div>

    <!-- CAR IMAGE -->
    <div class="car-image mb-3">
      <img
        [src]="car.carImages[selectedImageIndex] || 'assets/images/default_placeholder_image.png'"
        alt="{{ car.name }}"
        class="img-fluid rounded"
        appAutoCrop
        [cropThreshold]="70"
      />
    </div>

    <!-- IMAGE GALLERY -->
    <div class="car-gallery d-flex align-items-center justify-content-center gap-3 mb-4">
      <button
        class="gallery-nav prev"
        aria-label="Previous"
        (click)="onPrev()"
        *ngIf="car.carImages.length > 1"
      >
        ‹
      </button>
      <div class="thumbs d-flex gap-3" #thumbsRef>
        <img
          *ngFor="let thumb of car.carImages; index as i; trackBy: trackByIndex"
          [src]="thumb"
          alt="Thumbnail"
          class="gallery-thumb my-1"
          [class.active]="i === selectedImageIndex"
          (click)="onThumbClick(i)"
          (keyup.enter)="onThumbClick(i)"
        />
      </div>
      <button
        class="gallery-nav next"
        aria-label="Next"
        (click)="onNext()"
        *ngIf="car.images.length > 1"
      >
        ›
      </button>
    </div>

    <!-- ACCORDION SECTIONS -->
    <mat-accordion class="feature-accordion feature-tabs">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Safety & Comfort</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="safetyAndComfortFeatures.length; else noSafety">
          <div
            *ngFor="let feature of safetyAndComfortFeatures; trackBy: trackByIndexSafety"
            class="feature-chip ff-poppins-medium me-2"
          >
            {{ feature }}
          </div>
        </ng-container>
        <ng-template #noSafety>
          <div class="feature-chip ff-poppins-medium">No features listed</div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Exterior Features</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="exteriorFeatures.length; else noExterior">
          <div
            *ngFor="let feature of exteriorFeatures; trackBy: trackByIndexExterior"
            class="feature-chip ff-poppins-medium me-2"
          >
            {{ feature }}
          </div>
        </ng-container>
        <ng-template #noExterior>
          <div class="feature-chip ff-poppins-medium">No features listed</div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Interior Features</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="interiorFeatures.length; else noInterior">
          <div
            *ngFor="let feature of interiorFeatures; trackBy: trackByIndexInterior"
            class="feature-chip ff-poppins-medium me-2"
          >
            {{ feature }}
          </div>
        </ng-container>
        <ng-template #noInterior>
          <div class="feature-chip ff-poppins-medium">No features listed</div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <!-- RIGHT SECTION -->
  <div
    class="col-12 col-lg-6 right-panel p-3 p-md-4 d-flex flex-column justify-content-between position-relative"
  >
    <img
      style="top: 2%; right: 6%"
      class="position-absolute cursor-pointer"
      (click)="onClose()"
      (keyup.enter)="onClose()"
      alt="icon"
      src="icons/dialog_cross_btn.svg"
    />
    <div class="d-flex flex-column">
      <div class="subscription-options mb-4 pb-3">
        <h4 class="ff-poppins-semibold" style="color: rgba(53, 53, 53, 1)">Subscription Options</h4>
        <div class="option-tabs d-flex gap-2 mt-3">
          <button
            [ngClass]="{ active: selectedSubscription === 'per_minute' }"
            *ngIf="car.perMinuteRate && +car.perMinuteRate > 0"
            class="option-tab d-flex flex-column justify-content-center align-items-center"
            (click)="onSelectSubscription('per_minute')"
          >
            <span class="value ff-poppins-semibold"
              >{{ getDiscountedPrice(+car.perMinuteRate) | number: '1.0-0' }} QAR</span
            ><span class="meta">Per Minute</span>
          </button>
          <button
            [ngClass]="{ active: selectedSubscription === 'hourly' }"
            *ngIf="car.hourlyRate && +car.hourlyRate > 0"
            class="option-tab d-flex flex-column justify-content-center align-items-center"
            (click)="onSelectSubscription('hourly')"
          >
            <span class="value ff-poppins-semibold"
              >{{ getDiscountedPrice(+car.hourlyRate) | number: '1.0-0' }} QAR</span
            ><span class="meta">Per Hour</span>
          </button>
          <button
            [ngClass]="{ active: selectedSubscription === 'daily' }"
            *ngIf="car.dailyRate && +car.dailyRate > 0"
            class="option-tab d-flex flex-column justify-content-center align-items-center"
            (click)="onSelectSubscription('daily')"
          >
            <span class="value ff-poppins-semibold"
              >{{ getDiscountedPrice(+car.dailyRate) | number: '1.0-0' }} QAR</span
            ><span class="meta">Per Day</span>
          </button>
          <button
            [ngClass]="{ active: selectedSubscription === 'per_week' }"
            *ngIf="car.weeklyRate && +car.weeklyRate > 0"
            class="option-tab d-flex flex-column justify-content-center align-items-center"
            (click)="onSelectSubscription('per_week')"
          >
            <span class="value ff-poppins-semibold"
              >{{ getDiscountedPrice(+car.weeklyRate) | number: '1.0-0' }} QAR</span
            ><span class="meta">Per Week</span>
          </button>
          <button
            [ngClass]="{ active: selectedSubscription === 'per_month' }"
            *ngIf="car.monthlyRate && +car.monthlyRate > 0"
            class="option-tab d-flex flex-column justify-content-center align-items-center"
            (click)="onSelectSubscription('per_month')"
          >
            <span class="value ff-poppins-semibold"
              >{{ getDiscountedPrice(+car.monthlyRate) | number: '1.0-0' }} QAR</span
            ><span class="meta">Per Month</span>
          </button>
        </div>
      </div>

      <div class="location-section mb-3">
        <h4 class="mb-2 ff-poppins-medium" style="color: #919191">Car Delivery at</h4>
        <div class="location-selection-card pb-4 pe-md-3 pt-2">
          <div class="d-flex flex-column pickup-block py-3 px-2 input-field">
            <!-- pickup block -->
            <mat-radio-group [(ngModel)]="pickupType" class="d-flex flex-column">
              <!-- Self Pickup -->
              <mat-radio-button value="self_pickup">
                <div class="d-flex flex-column">
                  <h5 class="mb-1 ff-poppins-semibold" style="color: #000">Self Pickup</h5>
                  <h6 class="m-0 ff-poppins" style="color: #707070">
                    You will be picking up car from our nearest showroom.
                  </h6>
                </div>
              </mat-radio-button>

              <div class="input-field px-3 mt-2" *ngIf="pickupType === 'self_pickup'">
                <label class="field-label" style="color: #000">Pick-up Location</label>
                <mat-form-field appearance="outline" class="search-input-field w-100">
                  <mat-select
                    placeholder="Please select pick-up location"
                    [(ngModel)]="pickupLocation"
                    [compareWith]="comparePickupLocation"
                  >
                    <ng-container
                      *ngIf="locationAutocompleteList$ | async as locationAutocompleteList"
                    >
                      <mat-option
                        *ngFor="
                          let option of locationAutocompleteList;
                          trackBy: trackByIndexLocations
                        "
                        [value]="option"
                      >
                        {{ option.name }}
                      </mat-option>
                      <mat-option *ngIf="locationAutocompleteList.length === 0" [value]="null">
                        No Results Found
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </div>
              <hr class="mx-3" style="border-top-color: #346da3c4 !important" />
              <!-- Car Delivery -->
              <mat-radio-button value="car_delivery">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-1 ff-poppins-semibold" style="color: #000">Car Delivery</h5>
                    <h5
                      class="mb-1 ff-poppins-medium pe-3"
                      style="font-size: 18px; color: var(--primary-color)"
                    >
                      {{
                        (additionalDriverPrice$ | async)?.price
                          | currency: 'QAR ' : 'symbol' : '1.2-2'
                      }}
                    </h5>
                  </div>
                  <h6 class="m-0 ff-poppins" style="color: #707070">
                    Our driver will be drop off car at your location.
                  </h6>
                </div>
              </mat-radio-button>

              <div
                class="input-field d-flex flex-column col-12 px-3 mt-3"
                *ngIf="pickupType === 'car_delivery'"
              >
                <label class="field-label" style="color: #000"
                  >{{ 'Delivery Location' | translate }}
                </label>
                <mat-form-field appearance="outline" class="search-input-field w-100">
                  <img
                    src="/icons/ic_delivery_location.svg"
                    alt="location icon"
                    class="mx-2"
                    matPrefix
                  />
                  <input
                    type="text"
                    matInput
                    placeholder="{{ 'Please enter delivery location' | translate }}"
                    [ngModel]="pickupLocation?.name"
                    (input)="onPickupInput($event)"
                  />
                </mat-form-field>
              </div>
            </mat-radio-group>
          </div>

          <!-- Return Location Toggle -->
          <mat-slide-toggle [(ngModel)]="sameLocation" hideIcon class="mt-3">
            <h5 class="m-0 ff-poppins-semibold">&nbsp;Car will be returned to same location.</h5>
          </mat-slide-toggle>

          <!-- Drop-off Location -->
          <div class="input-field mt-2" *ngIf="!sameLocation">
            <label class="field-label" style="color: #000">Drop-off Location</label>
            <mat-form-field appearance="outline" class="search-input-field w-100">
              <mat-select
                placeholder="Please select drop-off location"
                [(ngModel)]="dropoffLocation"
                [compareWith]="compareDropoffLocation"
              >
                <ng-container *ngIf="locationAutocompleteList$ | async as locationAutocompleteList">
                  <mat-option
                    *ngFor="let option of locationAutocompleteList; trackBy: trackByIndexLocations"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-option>
                  <mat-option *ngIf="locationAutocompleteList.length === 0" [value]="null">
                    No Results Found
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <section class="info-box p-3 d-flex justify-content-between align-items-center me-md-3 mb-3">
        <div class="d-flex align-items-center gap-2" *ngIf="!isUnlimitedKM">
          <!-- <img src="/icons/ic_info_car_detail_card.svg" alt=""> -->
          <mat-slide-toggle [(ngModel)]="isUnlimitedKM" hideIcon></mat-slide-toggle>
          <p class="m-0 ff-poppins-medium" style="color: #0a0a0a">
            <span class="ff-poppins-bold" style="color: #c6a808">Kilometre Allowance:&nbsp;</span
            >{{ car.kilometerAllowance }} KM Included
          </p>
        </div>
        <div class="d-flex align-items-center gap-2" *ngIf="isUnlimitedKM">
          <!-- <img src="/icons/ic_info_car_detail_card.svg" alt=""> -->
          <mat-slide-toggle [(ngModel)]="isUnlimitedKM" hideIcon></mat-slide-toggle>
          <p class="m-0 ff-poppins-medium" style="color: #0a0a0a">
            <span class="ff-poppins-bold" style="color: #c6a808">Unlimited KM Allowance</span>
          </p>
        </div>
        <h5
          *ngIf="isUnlimitedKM"
          class="m-0 ff-poppins-medium"
          style="font-size: 16px; color: #000"
        >
          {{ (unlimitedKMAllowancePrice$ | async)?.price | currency: 'QAR ' : 'symbol' : '1.0-0' }}
        </h5>
      </section>
    </div>

    <div class="d-flex flex-column me-md-3 mt-5">
      <div class="price-section mb-4">
        <h4 class="mb-0 d-flex align-items-center">
          <img
            src="/icons/ic_info_car_detail_card.svg"
            alt=""
            class="cursor-pointer"
            matTooltip="You must be at least 25 years old to book a car."
          />&nbsp;
          <span class="amount ff-poppins-semibold">
            {{ getDiscountedPrice(+selectedPrice!) | currency: 'QAR ' : 'symbol' : '1.0-0' }} </span
          >&nbsp;
          <span class="per">
            <ng-container [ngSwitch]="selectedSubscription">
              <span *ngSwitchCase="'per_minute'">Per Minute</span>
              <span *ngSwitchCase="'hourly'">Per Hour</span>
              <span *ngSwitchCase="'daily'">Per Day</span>
              <span *ngSwitchCase="'per_week'">Per Week</span>
              <span *ngSwitchCase="'per_month'">Per Month</span>
              <span *ngSwitchDefault>Per Day</span>
            </ng-container>
          </span>
        </h4>
      </div>
      <button
        type="button"
        mat-raised-button
        class="btn-submit px-4 py-2"
        (click)="onContinueClick()"
        [disabled]="!pickupLocation"
      >
        Continue
      </button>
    </div>
  </div>
</div>
